import { createContext, Dispatch, ReactNode, SetStateAction, useMemo, useState } from 'react';
import User from '../models/User';

type UserContextType = {
  user: User;
  setUser: Dispatch<SetStateAction<any>>;
  isLoggedIn: boolean;
  setIsLoggedIn: Dispatch<SetStateAction<any>>;
}

const UserContext = createContext<UserContextType>({
  user: {
    name: '',
  },
  setUser: () => undefined,
  isLoggedIn: false,
  setIsLoggedIn: () => undefined,
});

export function UserContextProvider(props: { children: ReactNode }) {
  const [user, setUser] = useState({
    name: '',
  });
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const providerValue = useMemo(() => ({
    user,
    setUser,
    isLoggedIn,
    setIsLoggedIn,
  }), [user, isLoggedIn]);

  return (
    <UserContext.Provider value={providerValue}>
      {props.children}
    </UserContext.Provider>
  );
}

export default UserContext;

